import { ReactElement, useContext, useEffect } from "react";
import { DialogType } from "modules/dialogNotification/constants";
import { useI18n } from "i18n";
import { useSelector } from "react-redux";
import { Events, TRACKING_CONTEXT } from "modules/tracking";
import { selectIsMeBroadcaster } from "modules/broadcaster";
import { useAppDispatch } from "store/hooks";
import {
  addDialogNotification,
  closeDialogNotificationsByType,
} from "modules/dialogNotification/redux/dialogNotificationSlice";
import useJoinStage from "./hooks/useJoinStage";
import useBroadcasterActions from "./hooks/useBroadcasterActions";

interface Props {
  theaterId: string;
}

const BroadcasterSubscriber = ({ theaterId }: Props): ReactElement => {
  const dispatch = useAppDispatch();
  const { t } = useI18n(["menu", "event"]);
  const isMeBroadcaster = useSelector(selectIsMeBroadcaster);
  const { unsubscribe, subscribe } = useBroadcasterActions();
  const { track } = useContext(TRACKING_CONTEXT);
  const { joinStage } = useJoinStage();

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    dispatch(
      closeDialogNotificationsByType(DialogType.BROADCASTER_NOTIFICATION),
    );

    if (isMeBroadcaster) {
      track(Events.ADDED_TO_STAGE_EXECUTED);

      // Guest is added to / present in stage (Requested to join with camera)
      track(Events.ADDED_TO_STAGE_STREAMING_REQUESTED);

      dispatch(
        addDialogNotification({
          type: DialogType.BROADCASTER_NOTIFICATION,
          title: t("event:join.stage"),
          message: t("event:speaker.host.dialogue"),
          dismissText: t("event:join"),
          optionText: t("event:join.with.mic"),
          confirmText: t("event:join.with.mic.cam"),
          onDismiss: () => joinStage({ withMic: false, withCam: false }),
          onOption: () => joinStage({ withMic: true, withCam: false }),
          onConfirm: () => joinStage({ withMic: true, withCam: true }),
          actionStyles: {
            "@media (max-width: 600px)": {
              flexDirection: "column",
            },
          },
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMeBroadcaster]);

  useEffect(() => {
    subscribe({ theaterId });

    return unsubscribe;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <></>;
};

export default BroadcasterSubscriber;
